import type { KAPLAYCtx } from '../types.ts'
import type { RoomOptions } from '../types.ts'
import { useLang } from '../providers/i18n/i18n.ts'
import { useGameUiTextFrame } from '../objects/game-ui-text-frame.ts'
import { getTiledSize, parsePolygon, getFileCacheStr } from '../utils.ts'

export function useWC(k: KAPLAYCtx) {
  const cacheStr = getFileCacheStr()
  k.loadSprite('wc', `sprites/rooms/wc.png?${cacheStr}`)
  k.loadSprite('wcHover', `sprites/rooms/wc--hover.png?${cacheStr}`)
  const collidersJson = k.loadJSON('wcColliders', `colliders/wc.parsed.json?${cacheStr}`)

  const { showTextFrame } = useGameUiTextFrame(k)
  const { getLangString } = useLang(k)

  function setWC(roomOpts?: RoomOptions) {
    roomOpts = roomOpts || {}

    const roomObj = k.add()

    k.onLoad(() => {
      const { data } = collidersJson

      roomObj.add([
        k.sprite('wc', {
          width: getTiledSize(data.width),
          height: getTiledSize(data.height),
        }),
        k.layer('background'),
        'wc_background',
        'background',
      ])

      roomObj.add([
        k.sprite('wcHover', {
          width: getTiledSize(data.width),
          height: getTiledSize(data.height),
        }),
        k.layer('hover'),
        'wc_hover',
        'hover',
      ])

      data.objects.forEach((obj: any) => {
        const poly = parsePolygon(k, obj)
        roomObj.add([k.pos(), k.area({ shape: poly }), k.body({ isStatic: true }), 'colliders'])
      })

      roomObj.add([
        k.level(
          [
            '         ',
            ' 1       ',
            '         ',
            '         ',
            '         ',
            '         ',
            '         ',
            '         ',
            ' ?       ',
            '         ',
            '         ',
            '         ',
            '         ',
            '         ',
          ],
          {
            tileWidth: getTiledSize(),
            tileHeight: getTiledSize(),
            tiles: {
              '1': () => [
                k.rect(getTiledSize(), getTiledSize(), { fill: false }),
                k.area({ isSensor: true }),
                'wc_door_exit',
                'door_exit',
                'door',
              ],
              '?': () => [
                k.sprite('overlay', { anim: 'question' }),
                k.area({ isSensor: true }),
                k.layer('background'),
                'wc_info',
                'sfx_emit_action',
                'info',
              ],
            },
          },
        ),
        k.layer('objects'),
        'wc',
      ])

      // Set player position
      k.get('player')[0]?.setPos(k.vec2(getTiledSize(1.5), getTiledSize(2)))

      const doorExitCollision = k.onCollide('player', 'wc_door_exit', () => {
        k.flash(k.BLACK, 0.5)
        roomObj.destroy()
        doorExitCollision.cancel()
        infoCollision.cancel()
        infoCollisionEnd.cancel()
        if (roomOpts.onExit) roomOpts.onExit()
      })

      const infoCollision = k.onCollide('player', 'wc_info', () => {
        showTextFrame(getLangString('wc_info'))
      })

      const infoCollisionEnd = k.onCollideEnd('player', 'wc_info', () => {
        showTextFrame()
      })
    })

    return roomObj
  }

  return {
    setWC,
  }
}
